import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import {
  HEADER_CONSTANTS, // ヘッダータイトル
  API_FLAG,
  OTHER_SUBSCRIPTION_INSURANCE_STATUSES,
  EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS,
  EXISTANCE_FLAG,
} from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import dialogLoader from '../utilities/dialogLoader';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { GreenService } from '../services/GreenFile'; // 労安項目情報API
import { CompanyService } from '../services/Companies';
import { AttachDocuments } from '../services/AttachDocuments';
import UsersApi from '../services/users/UsersApi';
import { PartnerNaviList } from '../components/list/PartnerNaviList';
import { PartnerCompanyBranchDropdown } from '../components/PartnerCompanyBranchDropdown';
import { PartnerCompanyBranchSafetyForm } from '../components/forms/PartnerCompanyBranchSafetyForm';
import PartnerCompanyBranchService from '../services/PartnerCompanyBranch';
import Information from '../components/modals/common/Information';
import {
  INSURANCE_STATUS,
  HEALTH_INSURANCE_FLAG,
  PENSION_FLAG,
  EMPLOYMENT_INSURANCE_FLAG,
} from '../utilities/companySafetyUtil';
import { attachDocumentCompanyDownload } from '../utilities/attachDocumentUtil';
import {
  getPartnerCompanyName,
  propsToCompanyId,
} from '../utilities/partnerCompanyConfirmUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { FormInformationDialog } from '../components/FormInformationDialog';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { safariOnIosCheck } from '../utilities/stringUtil';
import { RegionalDevelopmentBureauxService } from '../services/RegionalDevelopmentBureaux';

/**
 * 会社情報確認 画面  労務安全項目 タブ
 * 画面遷移
 *  - 協力会社管理者でログイン > 会社情報確認 > 労務安全項目
 */
export class PartnerCompanyBranchSafetyPreview extends React.Component {
  constructor(props) {
    super(props);

    this.selectedCompanyId = propsToCompanyId(this.props);
    this.isOwnCompany =
      Number(
        SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany()
      ) === this.selectedCompanyId;

    this.events = {
      form: {
        download: this.download,
      },
      goBack: this.goBack,
    };

    this.state = {
      isBuildeeManager: false,
      isLoading: false,
      hasNoData: true,
      userId: LocalStorageService.getUserId(),
      errorMessages: {}, // エラーメッセージ
      visibleDialogFlag: false,
      selectedCompanyName: '',
      checkboxList: {
        construct_permit_source_types: {}, // 許可元区分名
        construct_permit_types: {}, // 建設許可区分名
        insurance_statuses: {}, // 健康保険、年金保険、雇用保険の加入状態
      },
      documentCodes: [],
      bureaux: [], // 振興局（APIから取得）

      partnerCompanyBranch: {
        name: '',
        id: '',
        block_flag: '',
      },

      formValues: {
        // 代表者情報
        company_detail: {
          delegate_name: '', // 代表者名
          delegate_name_kana: '', // 代表者名フリガナ
          delegate_post: '', // 代表者名役職
          construction_industry_permission_flag: '', // 建設業許可有無フラグ
          other_industry_permission_flag: '',
        },
        old_company_permission_documents: [],

        // 許可情報
        company_branch_permissions: [],
        other_company_branch_permission_groups: [],

        // 保険情報
        company_branch_insurance: {
          health_insurance_flag: '', // 健康保険_加入状況
          ccus_health_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_健保
          health_insurance_reason_exclusion: '', // 健康保険_適用除外理由
          health_insurance_uninsured_reason: '', // 健康保険_(未加入の)理由
          health_insurance_type_code: '', // 健康保険_健康保険種類コード
          health_insurance_type: '', // 健康保険_健康保険種類
          health_insurance_name_insurer: '', // 健康保険_健康保険者名称
          health_insurance_office_symbol: '', // 健康保険_事業所整理記号
          health_insurance_office_number: '', // 健康保険_事業所整理番号
          pension_flag: '', // 年金保険_加入状況
          ccus_pension_reason_exclusion_code: '', // 社会保険適用外理由コード_年金
          pension_reason_exclusion: '', // 年金保険_適用除外理由
          pension_uninsured_reason: '', // 年金保険_(未加入の)理由
          pension_type_code: '', // 年金保険_年金種類コード
          pension_type: '', // 年金保険_年金保険種類名称
          pension_office_symbol: '', // 年金保険_事業所整理記号
          pension_office_number: '', // 年金保険_事業所番号
          employment_insurance_flag: '', // 雇用保険_加入状況
          ccus_employment_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_雇用
          employment_insurance_reason_exclusion: '', // 雇用保険_適用除外理由
          employment_insurance_uninsured_reason: '', // 雇用保険_(未加入の)理由
          employment_insurance_insurance_number: '', // 雇用保険_労働保険番号
          other_subscription_flag: '0', // その他退職金共済加入状況
        },
      },

      // ccusフォーム
      ccusformValues: {
        // 代表者情報
        ccus_jigyousyas: {
          daihyousya_name: '', // 代表者名
          daihyousya_kana_name: '', // 代表者名フリガナ
          construct_permit_availability: '', // 建設業許可有無フラグ
          construct_permit_number_type: '', // 許可元区分名「空白/00～47」
          jigyousya_construct_permit_source_type: '', // 許可元区分名「0,1,2」
          business_name: '', // 許可業種名
          construct_permit_number_year: '', // 許可番号年度
          construct_permit_number: '', // 許可番号固有番号
          start_date: '', // 許可年月日
          health_ins_status: '', // 健康保険加入状況
          health_ins_exclusion: '', // 健康保険適用除外理由
          health_ins_name: '', // 健康保険者名称
          health_ins_jigyousyo_symbol: '', // 健康保険事業所整理記号
          health_ins_jigyousyo_number: '', // 健康保険事業所番号
          pension_ins_status: '', // 年金保険加入状況
          pension_ins_exclusion: '', // 年金保険適用除外理由
          pension_ins_jigyousyo_symbol: '', // ccus年金保険事業所整理記号
          pension_ins_jigyousyo_number: '', // ccus年金保険事業所番号
          employment_ins_status: '', // ccus雇用保険加入状況
          employment_ins_exclusion: '', // ccus雇用保険適用除外理由
          employment_ins_number: '', // ccus雇用保険労働保険番号
          workmans_comp_ins_status: '', // ccus労災保険特別加入状況
          workmans_comp_ins_number: '', // ccus労災保険特別加入労働保険番号
          workmans_comp_ins_reference_number: '', // ccus労災保険特別加入整理番号
          kentaikyo_status: '', // ccus建退共制度加入状況
          kentaikyo_contractor_number: '', // ccus建退共契約者番号
          chutaikyo_status: '', // ccus中退共制度加入状況
          chutaikyo_contractor_number: '', // ccus中退共契約者番号
        },
      },
      expirationCompany: {},
    };
    this.defaultParams = {
      block_flags: [false, true],
      order: 'block_flag_asc',
    };
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  async componentDidMount() {
    this.setCompanyName();

    await this.checkBuildeeMangerPermission();

    const params = {
      offset: 0,
      is_limit: 0,
    };

    AttachDocuments.documentCodes(params).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        documentCodes: response.data.entities.document_codes,
      });
    });

    const selectedPartnerCompanyBranchId = _.get(
      this.props,
      'view.state.selectedPartnerCompanyBranchId'
    );
    if (selectedPartnerCompanyBranchId) {
      this.getPartnerCompanyBranch(selectedPartnerCompanyBranchId).then(
        response => {
          if (response) {
            this.initForm(response);
          } else {
            this.showErrorDialog();
          }
        }
      );
    } else {
      this.getPartnerCompanyBranchList();
    }
    this.getExpiration();
  }

  setCompanyName = () => {
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        const companyName = await getPartnerCompanyName(this.selectedCompanyId);
        this.setState({ selectedCompanyName: companyName, isLoading: false });
      }
    );
  };

  /**
   * 労務安全情報取得
   */
  getGreenData = branchId => {
    const ignoredKeys = [
      'worker_compensation_flag',
      'worker_compensation_number',
      'worker_compensation_organize_number',
      'worker_add_on_compensation_flag',
      'const_subscription_flag',
      'const_subscription_number',
      'enterprise_subscription_flag',
      'enterprise_subscription_number',
      'other_subscription_flag',
      'other_subscription_name',
      'acceptance_foreign_workers_flag',
      'certification_number',
      'supervisor_worker_id',
      'supervisor_name',
      'supervisor_position_name',
      'supervisor_tel',
      'leader_worker_id',
      'leader_name',
      'leader_position_name',
      'work_place',
      'engagement_content',
      'engagement_start_date',
      'engagement_end_date',
    ];
    GreenService.getPartnerCompanyBranchGreenFiles(
      this.selectedCompanyId,
      branchId
    ).then(response => {
      if (!response.result) {
        this.setState({ isLoading: false });
        return;
      }
      const formValues = _.cloneDeep(this.state.formValues);
      const responseData = response.data.entities;
      _.map(responseData, (company_data, company_key) => {
        if (company_data === null) {
          _.forEach(formValues[company_key], (data, key) => {
            formValues[company_key][key] = '';
          });
        } else if (
          !_.includes(EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS, company_key)
        ) {
          _.map(company_data, (data, key) => {
            if (!ignoredKeys.includes(key)) {
              formValues[company_key][key] = data;
            }
          });
        }
      });
      formValues.old_company_permission_documents = _.get(
        responseData,
        'old_company_permission_documents'
      );
      formValues.company_branch_permissions =
        _.get(responseData, 'common_company_branch_permission_groups') || [];
      formValues.company_detail.construction_industry_permission_flag =
        _.get(
          responseData,
          'company_detail.construction_industry_permission_flag'
        ) || EXISTANCE_FLAG.NOEXIST.VALUE;

      formValues.other_company_branch_permission_groups =
        responseData.other_company_branch_permission_groups;
      formValues.company_detail.other_industry_permission_flag =
        _.get(responseData, 'company_detail.other_permission_flag') ||
        EXISTANCE_FLAG.NOEXIST.VALUE;
      this.setState({ formValues });
    });

    // 振興局情報APIから取得
    RegionalDevelopmentBureauxService.list().then(response => {
      if (!response.result) {
        return;
      }
      const bureaux = response.data.entities.regional_development_bureaux;
      this.setState({ bureaux });
    });

    GreenService.ccus_list().then(response => {
      if (!response.result) {
        return;
      }

      const checkboxList = _.cloneDeep(this.state.checkboxList);
      const responseData = response.data.entities;
      _.forEach(responseData, (ccus_list_data, ccus_list_key) => {
        if (_.has(checkboxList, ccus_list_key)) {
          checkboxList[ccus_list_key] = ccus_list_data;
        }
      });
      this.setState({ checkboxList });
    });
  };

  initForm = companyBranchData => {
    if (companyBranchData) {
      this.getGreenData(companyBranchData.id);
      this.getPartnerCompanyDocument(companyBranchData.id, {
        offset: 0,
        is_limit: 0,
      });
      const { block_flag: blockFlag, name } = companyBranchData;

      this.setState({
        partnerCompanyBranch: {
          ...companyBranchData,
          formattedName: blockFlag ? `${name}（停止中）` : name,
        },
        hasNoData: false,
      });
    } else {
      this.setState({
        partnerCompanyBranch: {
          name: '',
          id: '',
          block_flag: '',
        },
      });
    }
  };

  getPartnerCompanyDocument = (partnerCompanyBranchId, params) => {
    CompanyService.getPartnerCompanyBranchDocuments(
      this.selectedCompanyId,
      partnerCompanyBranchId,
      params
    ).then(({ result, data }) => {
      if (result) {
        const { company_documents: companyDocuments } = data.entities;
        this.setState({ companyDocuments });
      }
    });
  };

  showErrorDialog = () => {
    dialogLoader.show(FormInformationDialog, {
      title: 'エラーが発生しました',
      message:
        'エラーが発生しました。会社情報を開きなおし、再度操作を行ってください。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('CompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  download = async fileId => {
    attachDocumentCompanyDownload(
      () => {
        this.setState({
          visibleDialogFlag: true,
        });
      },
      this.selectedCompanyId,
      fileId
    );
  };

  getPartnerCompanyBranchList = () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        PartnerCompanyBranchService.partnerCompanyBranchList(
          this.selectedCompanyId,
          this.defaultParams
        ).then(({ result, data }) => {
          if (result && _.has(data, 'entities.partner_company_branches')) {
            this.setState({ isLoading: false });
            this.initForm(data.entities.partner_company_branches[0]);
          } else {
            this.showErrorDialog();
          }
        });
      }
    );
  };

  getPartnerCompanyBranch = async id => {
    if (id) {
      const { data } = await PartnerCompanyBranchService.show(
        this.selectedCompanyId,
        id
      );
      return _.get(data, 'entities.partner_company_branch');
    }
  };

  checkBuildeeMangerPermission = async () => {
    // 企業管理者を取得
    const { data, result } = await UsersApi.fetchCompanyUserPermissions(
      this.selectedCompanyId,
      {
        buildee_manager_flg: 1,
      }
    );

    if (result && _.has(data, 'entities.company_user_permissions')) {
      const companyUserPermissions = _.get(
        data,
        'entities.company_user_permissions'
      );

      if (!_.isEmpty(companyUserPermissions)) {
        const userId = LocalStorageService.getUserId();
        if (Number(userId) === companyUserPermissions[0].user_id) {
          this.setState({
            isBuildeeManager: companyUserPermissions[0].buildee_manager_flg,
          });
        }
      }
    }
  };

  goBack = () => {
    const { partnerCompanyBranch } = this.state;
    return {
      callback: {
        clear: () => {
          _masterSlideLoader.show('PartnerCompanyBranchPreview', {
            state: {
              id: this.selectedCompanyId,
              selectedPartnerCompanyBranchId: partnerCompanyBranch.id,
            },
          });
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };
  };

  /**
   * stateのcheckboxListと対応するvaluesで一致するオブジェクトを返す
   * checkboxListはAPIからデータが返ってくるまで空
   */
  findStatus = (type, targetValue) => {
    const { checkboxList } = this.state;

    const fromInsuranceStatuses = targetValue => {
      if (!_.isEmpty(checkboxList.insurance_statuses)) {
        return this.state.checkboxList.insurance_statuses.find(
          item => item.value === targetValue
        );
      }
      return null;
    };

    switch (type) {
      case INSURANCE_STATUS:
      case HEALTH_INSURANCE_FLAG:
      case PENSION_FLAG:
      case EMPLOYMENT_INSURANCE_FLAG:
        return fromInsuranceStatuses(targetValue);
      default:
        return null;
    }
  };

  closeError = () => {
    this.setState({
      visibleDialogFlag: false,
    });
  };

  onClickEditButton = id => {
    SessionStorageService.setSelectedPartnerCompanyBranchSafetyId(id);
    SessionStorageService.setSessionSelectedPartnerCompanyId(
      this.selectedCompanyId
    );

    _masterSlideLoader.show('PartnerCompanyBranchSafetyEdit', {
      state: {
        id: this.selectedCompanyId,
      },
    });
  };

  handleSelectPartnerCompanyBranch = id => {
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        const branch = await this.getPartnerCompanyBranch(id);

        if (branch) {
          this.initForm(branch);
        } else {
          this.showErrorDialog();
        }

        this.setState({ isLoading: false });
      }
    );
  };

  redirectToAgencyCompanies = () => {
    _masterSlideLoader.show('AgencyCompanies', {
      state: {},
    });
  };

  render() {
    const {
      isLoading,
      hasNoData,
      selectedCompanyName,
      partnerCompanyBranch,
      formValues,
      errorMessages,
      checkboxList,
      ccusformValues,
      companyDocuments,
      documentCodes,
      visibleDialogFlag,
    } = this.state;
    const title = `${selectedCompanyName} 会社情報`;
    const isSuspended =
      partnerCompanyBranch.block_flag === Boolean(API_FLAG.On);
    const btnDisabled = !_.has(partnerCompanyBranch, 'id');
    const masterSlideViewBodyHeight = safariOnIosCheck()
      ? 'calc(100vh - 115px)'
      : 'calc(100vh - 84px)';
    const changePartnerCompanyBranchDropdownOptionDisplay = options => {
      const formatName = option => {
        const { block_flag: blockFlag, name } = option;
        const statusBlocked = '（停止中）';

        return blockFlag && !name.includes(statusBlocked)
          ? `${name}${statusBlocked}`
          : name;
      };
      return _.map(options, option => ({
        ...option,
        name: formatName(option),
      }));
    };

    return (
      <div className='contruction-slide-view show PartnerCompanyBranchSafetyPreview'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            loaded={!isLoading}
            loaderComponent={
              <div className='contruction-slide-view__title'>
                <ClipLoader size={20} color='#EDB715' />
              </div>
            }
            title={title}
            onClose={() => _masterSlideLoader.close()}
          />
          <div
            className='contruction-slide-view__body contruction-slide-view__body--height-fix'
            style={{ height: masterSlideViewBodyHeight }}
          >
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PartnerNaviList
                  isSelectedPartnerCompanyBranchSafetyPreview={true}
                  selectedPartnerCompanyId={this.selectedCompanyId}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {!this.isOwnCompany && (
                  <div style={{ padding: '10px 20px 0' }}>
                    <button
                      className='btn-text--sm'
                      onClick={this.redirectToAgencyCompanies}
                    >
                      <i className='i-back--blue i-2x vertical-middle' />
                      代行先一覧
                    </button>
                  </div>
                )}
                {!isLoading && !hasNoData && (
                  <React.Fragment>
                    <div className='PartnerCompanyBranchSafetyPreview__header'>
                      <PartnerCompanyBranchDropdown
                        selectedCompanyId={this.selectedCompanyId}
                        selectedPartnerCompanyBranchId={partnerCompanyBranch.id}
                        previewValue={partnerCompanyBranch.formattedName}
                        onSelect={this.handleSelectPartnerCompanyBranch}
                        params={this.defaultParams}
                        transformOptions={
                          changePartnerCompanyBranchDropdownOptionDisplay
                        }
                        responseParseKeys={[
                          {
                            keyName: 'block_flag',
                            defaultValue: false,
                          },
                        ]}
                      />
                      <span className='construction-detail-view__button'>
                        {!isSuspended && this.isOwnCompany && (
                          <button
                            className={
                              btnDisabled ? 'btn btn--disabled' : 'btn'
                            }
                            onClick={() =>
                              this.onClickEditButton(partnerCompanyBranch.id)
                            }
                            disabled={btnDisabled}
                          >
                            この支店を編集
                          </button>
                        )}
                      </span>
                    </div>
                    <div className='contruction-detail-view__bar' />
                    <PartnerCompanyBranchSafetyForm
                      values={formValues}
                      messages={errorMessages}
                      checkboxList={checkboxList}
                      ccusformValues={ccusformValues}
                      comboboxList={{}}
                      events={this.events.form}
                      readOnly={true}
                      companyDocuments={companyDocuments}
                      documentCodes={documentCodes}
                      partnerCompanyBranch={partnerCompanyBranch}
                      findStatusFn={this.findStatus}
                      bureaux={this.state.bureaux}
                      selectedCompanyId={this.selectedCompanyId}
                      eventCompanyBranchPermissionCommon={this.events.form}
                    />
                  </React.Fragment>
                )}
                {isLoading && <div className='indicator' />}
                <Information
                  title={
                    <div className='PartnerCompanyBranchSafetyPreview__infor'>
                      <i className='icon-error' />
                      <p>エラーが発生しました。</p>
                    </div>
                  }
                  message='指定されたファイルが存在しません。'
                  buttonText={messageUtility.getMessage('I-000-017')}
                  visible={visibleDialogFlag}
                  onClose={this.closeError}
                  multilineText
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerCompanyBranchSafetyPreview.jsx